import { createContext, useContext, useState } from "react";

type DialogContextType = {
  isNewConversationOpen: boolean;
  openNewConversation: () => void;
  closeNewConversation: () => void;
};

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export function DialogProvider({ children }: { children: React.ReactNode }) {
  const [isNewConversationOpen, setIsNewConversationOpen] = useState(false);

  const openNewConversation = () => setIsNewConversationOpen(true);
  const closeNewConversation = () => setIsNewConversationOpen(false);

  return (
    <DialogContext.Provider
      value={{
        isNewConversationOpen,
        openNewConversation,
        closeNewConversation,
      }}
    >
      {children}
    </DialogContext.Provider>
  );
}

export function useDialog() {
  const context = useContext(DialogContext);
  if (context === undefined) {
    throw new Error("useDialog must be used within a DialogProvider");
  }
  return context;
}
